import Button from "@app/sharedComponents/Button/Button";
import DashedLine from "@app/sharedComponents/DashedLine/DashedLine";
import NumStepper from "@app/sharedComponents/NumStepper/NumStepper";
import { ThemedText, ThemedView } from "@app/theme";

const CloseReasonInfo = ({info,buttonFn}) =>{
    const {btn1Fn,btn2Fn} = buttonFn
    return(
        <ThemedView p="lg" pb="xl">
            <ThemedText variant="h2s" color="text-primary" mb="md">Did you know?</ThemedText>
            <ThemedText variant="b3r" color="text-primary" mb="md">{info?.info}</ThemedText>
            <ThemedView p="sm" borderWidth={1} borderColor="border-primary" borderRadius="sm">
                <ThemedView flexDirection="row" alignItems="center">
                    {info?.icon}
                    <ThemedText variant="b3s" color="text-primary" ml="md">{info?.subTitle}</ThemedText>
                </ThemedView>
                <ThemedView my="lg" >
                    <DashedLine/>
                </ThemedView>
                <NumStepper data={info.data}/>
            </ThemedView>
            <ThemedView  alignItems="center">
            <Button label={info?.btn1}  handlePress={btn1Fn} overRideStyle={{marginTop:16}}/>
            <Button type="TEXT" label={info?.btn2}  overRideStyle={{marginTop:16}} handlePress={btn2Fn}/>
            </ThemedView>

        </ThemedView>

    )
}

export default CloseReasonInfo;
